(() => {
  const updateEmailOffer = () => {
    const footer = document.querySelector('footer');
    if (!footer) return;

    const heading = Array.from(footer.querySelectorAll('h2')).find(
      (element) => element.textContent.trim() === 'Join our email list'
    );
    if (heading) {
      heading.textContent = 'Get 5% off your first order';
    }

    const description = Array.from(footer.querySelectorAll('p')).find((element) =>
      element.textContent.trim().startsWith('Be the first to hear about new products')
    );
    if (description) {
      description.textContent =
        'Join our email list for new releases and special offers. Get 5% off your first order with no minimum purchase. Your code appears after you subscribe. One use per customer. Cannot be combined with other discounts.';
    }

    const submitButton = footer.querySelector('.email-signup__button');
    if (submitButton) {
      submitButton.setAttribute('aria-label', 'Get my welcome offer');
      submitButton.setAttribute('title', 'Get my welcome offer');
    }

    const successMessage = footer.querySelector(
      '[id^="Email-signup__message-success"] .email-signup__message-text'
    );
    const successCopy = 'Thanks for signing up. Use code WELCOME5PCT for 5% off your first order. No minimum purchase. One use per customer. Cannot be combined with other discounts.';
    if (successMessage && successMessage.textContent.trim() !== successCopy) {
      successMessage.textContent = successCopy;
      successMessage.classList.add('ah-welcome-code');
    }
  };

  const addMobileFrostBuddyLink = (root = document) => {
    const frostBuddyDetails = root.querySelector?.('#Details-menu-drawer-drinkware-frostbuddy');
    const list = frostBuddyDetails?.querySelector('.menu-drawer__menu--grandchildlist');
    if (!list || list.querySelector('[data-ah-frostbuddy-all]')) return;

    const item = document.createElement('li');
    item.className = 'menu-drawer__list-item';
    item.style.setProperty('--menu-drawer-animation-index', '0');
    item.dataset.ahFrostbuddyAll = '';
    item.innerHTML = `
      <a
        href="/collections/frost-buddy"
        class="menu-drawer__menu-item menu-drawer__menu-item--child focus-inset ah-mobile-shop-all"
      >
        <span class="menu-drawer__menu-item-text wrap-text">Shop all FrostBuddy</span>
      </a>
    `;
    list.prepend(item);
  };

  let cartUpdateTimer;
  const updateFrostBuddyCartReminder = () => {
    clearTimeout(cartUpdateTimer);
    cartUpdateTimer = window.setTimeout(async () => {
      const openDrawerSurface = document.querySelector(
        'cart-drawer-component dialog[open] form[action="/cart"], cart-drawer dialog[open] form[action="/cart"]'
      );
      const cartPageSurface = document.querySelector('form.shopify-cart-form');
      const cartSurfaces = [openDrawerSurface || cartPageSurface].filter(Boolean);

      if (!cartSurfaces.length) return;

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) return;

        const cart = await response.json();
        const frostBuddyQuantity = cart.items
          .filter((item) => item.handle?.startsWith('frostbuddy-'))
          .reduce((total, item) => total + item.quantity, 0);

        if (!frostBuddyQuantity) {
          document.querySelectorAll('[data-ah-cart-bundle-reminder]').forEach((reminder) => reminder.remove());
          return;
        }

        const qualifies = frostBuddyQuantity >= 2;
        document.querySelectorAll('[data-ah-cart-bundle-reminder]').forEach((reminder) => {
          if (!cartSurfaces.some((surface) => surface.contains(reminder))) reminder.remove();
        });

        cartSurfaces.forEach((surface) => {
          const state = qualifies ? 'qualified' : 'one-away';
          let reminder = surface.querySelector('[data-ah-cart-bundle-reminder]');
          if (reminder?.dataset.ahCartBundleState === state) return;

          if (!reminder) {
            reminder = document.createElement('aside');
            reminder.className = 'ah-cart-bundle-reminder';
            reminder.dataset.ahCartBundleReminder = '';
            reminder.setAttribute('aria-live', 'polite');

            const target =
              surface.querySelector('.cart__summary, .cart-drawer__summary, [class*="cart__footer"], [class*="totals"]') ||
              surface.lastElementChild;
            target?.parentNode?.insertBefore(reminder, target);
          }

          reminder.dataset.ahCartBundleState = state;
          reminder.innerHTML = qualifies
            ? `
              <strong>15% off applied to your FrostBuddys.</strong>
              <span>The discount is already in your total below &mdash; no code needed.</span>
            `
            : `
              <strong>You’re one FrostBuddy away from 15% off.</strong>
              <span>A second one adds only two to four dollars to shipping &mdash; they go in the same box.</span>
              <a href="/collections/frost-buddy">Add another FrostBuddy</a>
            `;
        });
      } catch (error) {
        // Leave the native cart untouched if Shopify's cart endpoint is unavailable.
      }
    }, 120);
  };

  const compactMobileChat = (root = document) => {
    const chat = root.querySelector?.('shopify-chat');
    if (!chat?.shadowRoot || chat.shadowRoot.querySelector('[data-ah-mobile-chat-style]')) return;

    const style = document.createElement('style');
    style.dataset.ahMobileChatStyle = '';
    style.textContent = `
      @media (max-width: 749px) {
        .activator {
          width: 48px !important;
          min-width: 48px !important;
          padding-inline: 0 !important;
          justify-content: center !important;
        }

        .activator__label {
          display: none !important;
        }
      }
    `;
    chat.shadowRoot.append(style);
  };

  const start = () => {
    updateEmailOffer();
    addMobileFrostBuddyLink();
    updateFrostBuddyCartReminder();
    compactMobileChat();

    new MutationObserver(() => {
      updateEmailOffer();
      addMobileFrostBuddyLink();
      updateFrostBuddyCartReminder();
      compactMobileChat();
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
